module.exports = __webpack_public_path__ + "img/used_renxin.911b54ee.png";